import { getUrl, sessionExpired } from "../setEnvironment";

class ParametersAPI {
  constructor() {
    this.URL = getUrl();
    this.createParameter = this.createParameter.bind(this);
    this.getAllParameters = this.getAllParameters.bind(this);
    this.deleteParameter = this.deleteParameter.bind(this);
    // this.updateComponent = this.updateComponent.bind(this)
  }

  // P01021-137: el usuario se resuelve en el backend a partir del token de sesión.
  async createParameter(ip, port, token) {
    try {
      const response = await fetch(this.URL + "/plc/createSecurityParams", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          ip: ip,
          port: port,
        }),
      }).catch(function (e) {
        console.log(e);
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      console.log(e);
      throw e;
    }
  }

  // P01021-137: el usuario se resuelve en el backend a partir del token de sesión.
  async deleteParameter(ip, token) {
    try {
      const response = await fetch(this.URL + "/plc/deleteSecurityParam", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          ip: ip,
        }),
      }).catch(function (e) {
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }

  // P01021-137: el usuario se resuelve en el backend a partir del token de sesión.
  async getAllParameters(token) {
    try {
      const response = await fetch(
        this.URL + "/plc/getPLCParams",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      ).catch(function (e) {
        console.log(e);
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json;
    } catch (e) {
      throw e;
    }
  }
}

let _componentsAPI = null;

const initParametersAPI = () => {
  if (!_componentsAPI) {
    _componentsAPI = new ParametersAPI();
  }
  return _componentsAPI;
};

const getParametersAPI = () => {
  return initParametersAPI();
};

export { initParametersAPI, getParametersAPI };
